<template>
    <div class="report-rtc-table">
        <b-row class="rtc-heading">
            <div class="col">{{ $i18n.gt('RTC_QUESTION_LABEL')}}</div>
            <div class="col">{{ $i18n.gt('RTC_IC_LABEL')}}</div>
            <div class="col">{{ $i18n.gt('RTC_RTC_LABEL')}}</div>
        </b-row>
        <div>
            <b-row class="mindset__section-heading">{{ $i18n.gt('QUESTIONNAIRE_RTC_SECTION_WELLBEING_TITLE')}}</b-row>
            <div class="pt-3 pb-1">
                <b-row v-for="(key, i) in widgetKeys[0]" :key="`meter0_${i}`">
                    <report-widget :widget-key="key"/>
                </b-row>
            </div>

            <b-row class="mindset__section-heading">{{ $i18n.gt('QUESTIONNAIRE_RTC_SECTION_HEALTH_BEHAVIORS_TITLE')}}</b-row>
            <div class="pt-3 pb-1">
                <b-row v-for="(key, i) in widgetKeys[1]" :key="`meter1_${i}`">
                    <report-widget :widget-key="key"/>
                </b-row>
            </div>

            <b-row class="mindset__section-heading">{{ $i18n.gt('QUESTIONNAIRE_RTC_SECTION_SUBSTANCE_USE_TITLE')}}</b-row>
            <div class="pt-3 pb-1">
                <b-row v-for="(key, i) in widgetKeys[2]" :key="`meter2_${i}`">
                    <report-widget :widget-key="key"/>
                </b-row>
            </div>
        </div>
    </div>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>
import Vue from 'vue'

/**
 *  Table containing all RTC scores for a Participant
 */
export default Vue.extend({
    props: {
        widgetKeys: Array,
    }
})
</script>

<style lang="scss">

    .report-rtc-table{

        .rtc-heading {
            text-align: center;
            text-transform: uppercase;
            padding-bottom: 1em;
        }

        .mindset__section-heading {
            font-size: 1.1em;
            justify-content: center;
            padding: .8em 0;
            font-weight: bold;
            background-color: #eee;
        }
    }

</style>
